import { render, staticRenderFns } from "./product_update.vue?vue&type=template&id=09fcc506&scoped=true&"
import script from "./product_update.vue?vue&type=script&lang=js&"
export * from "./product_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fcc506",
  null
  
)

export default component.exports